<template>
  <div>
    <asn-query v-show="activeKey===1" ref="list" :orderStatus="orderStatus" :owners="owners" @add="add" @getDetail="getDetail"/>
    <asn-edit v-show="activeKey===2" ref="detail" :owners="owners" @back="back"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import AsnQuery from '@/views/inbound/asn/AsnQuery'
import AsnEdit from '@/views/inbound/asn/AsnEdit'
import { getEnums, getOptions } from '@/utils/util'

export default {
  name: 'Asn',
  components: { AsnQuery, AsnEdit },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      activeKey: 1,
      orderStatus: [],
      owners: []
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getEnums('OrderStatus')
    }).then(result => {
      this.orderStatus = result
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.fetch()
    },
    getDetail(row) {
      this.activeKey = 2
      this.$refs.detail.fetchOrderById(row.order.id)
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.init()
      this.$refs.detail.add()
    }
  }
}
</script>